module.exports = __webpack_public_path__ + "static/img/apply_changes.8ebcaf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/c/images/apply_changes.png
// module id = RCPB
// module chunks = 1